import React, { Component } from "react";
import { NotificationMenuContainer, NotificationListContainer } from "./style";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { BoxLoading } from "../../../../../components/loading/components/boxLoading/index";
import Notify from "../../../../../components/notify/index";
import SelectBox from "../../../../../components/selectbox/index";
import {
  NotificationAction,
  InvitationAction,
  FeedbackAction
} from "../../../../../actions/index";
import FeedbackModal from "./feedbackModal";
import { EmptyState } from "../../../../../components/emptyState/index";
import { Menu } from "../../../header/components/menu/index";
import NOTIFICATION_WITH_ACTIONS_TYPES from "../../../../../constants/notificationTypes";
import * as NOTIFICATION_ACTION_TYPES from "../../../../../constants/notificationActionTypes";
import NOTIFICATION_SORT_TYPES from "../../../../../constants/notificationSortTypes";
import {PAYMENT, RECEIVE} from "../../../../../constants/accountReviewActionTypes";
import {Confirm} from "../../../../../components/confirm";
import queryString from "query-string";
import ProjectState from "../../../../../constants/projectState";
import {EXPIRED_PREMIUM, FREE} from "../../../../../constants/premiumState";
import GuestsDeniedModal from "../../../../../containers/app/components/accessDeniedOrReminderModals/guestsDeniedModal";
import {isEqual} from "lodash";

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSeen: [],
      requestedFeedbackNotifyId: "",
      selected_sort: NOTIFICATION_SORT_TYPES[0],
      showModal: false,
      listData: this.props.list,
      showConfirm:false,
      project:{},
      cheque:{type:"", id:""},
      accessDeniedModalShow:false,
    };
    this.okAction = this.okAction.bind(this);
    this.closeFeedbackModal = this.closeFeedbackModal.bind(this);
  }

  componentDidMount() {
    this.props.getNotifications(this.state.selected_sort.key + 1);
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log(prevProps.list, this.props.list, this.state.listData, "dssdsd");
    if (!isEqual(this.props.list, prevProps.list)){
      this.setState({listData: this.props.list})
    }
  }

  okAction(id, doNotRead = false) {
    let _isSeen = this.state.isSeen;
    _isSeen[id] = true;
    const newList = this.state.listData.filter((item)=> item.id !== id);
    this.setState({ isSeen: _isSeen, listData: newList });
    if (doNotRead){
      this.props.readNotification(id);
    }

    this.decreaseBadgeNumber();
  }

  viewAnsAction(id, isRead) {
    this.props.getFeedback(id);
    if (!isRead) {
      this.props.readFeedbackNotification(id);
      this.decreaseBadgeNumber();
    }
    this.setState({ showModal: true, requestedFeedbackNotifyId: id });
    let _isSeen = this.state.isSeen;
    _isSeen[id] = true;
    this.setState({ isSeen: _isSeen});
  }

  invitationAction(response, id) {
    if (response) {
      this.props.acceptInvitation(id); //TODO: if this request fail I will read it :((
      this.okAction(id, true);
    } else {
      this.props.rejectInvitation(id); //TODO: if this request fail I will read it :((
      this.okAction(id, true);
    }
  }

  decreaseBadgeNumber() {
    const key = "unread_notifications_num";
    this.props.changeNumberOfUnreadNofication(
      (parseInt(localStorage.getItem(key)) - 1).toString()
    );
    localStorage.setItem(
      key,
      (parseInt(localStorage.getItem(key)) - 1).toString()
    );
  }

  actionsHandler(type, id, isRead, model_type, project, link) {
    switch (type) {
      case NOTIFICATION_ACTION_TYPES.OK:
        return () => this.okAction(id);
      case NOTIFICATION_ACTION_TYPES.VIEW_ANS:
        return () => this.viewAnsAction(id, isRead);
      case NOTIFICATION_ACTION_TYPES.ACCEPT:
        return () => this.invitationAction(true, id);
      case NOTIFICATION_ACTION_TYPES.REJECT:
        return () => this.invitationAction(false, id);
      case NOTIFICATION_ACTION_TYPES.CHANGE_CHEQUE_STATUS:
        if (project.project && (project.project.id == localStorage.getItem("project_id"))){
          if (model_type == PAYMENT)
            return () => this.props.history.push(`/summary-payment/${id}`);
          else if (model_type == RECEIVE)
            return () => this.props.history.push(`/summary-receive/${id}`);
        }
        else {
          return () => this.setState({showConfirm:true, project, cheque:{type:model_type, id:id}})
        }
      case NOTIFICATION_ACTION_TYPES.MORE_INFO:
        return () => window.open(link, "_blank");
    }
  }

  handleChange(value) {
    this.props.getNotifications(value.key + 1); //TODO Error handle!!!
    this.setState({ selected_sort: value });
  }

  closeFeedbackModal() {
    const newList = this.state.listData.filter((item)=> item.id !== this.state.requestedFeedbackNotifyId);
    this.setState({ showModal: false, listData: newList });
    this.props.readFeedbackNotification(this.state.requestedFeedbackNotifyId);
    this.decreaseBadgeNumber();
  }

  changeProject(project){
    if (project.state === ProjectState.ACTIVE){
      if (!project.is_owner &&
          (project.project.premium_state === FREE || project.project.premium_state === EXPIRED_PREMIUM)){
        this.setState({
          accessDeniedModalShow: true,
          showConfirm:false
        });
      }
      else {
        localStorage.setItem(
            "project_info",
            JSON.stringify({ ...project.project, is_owner: project.is_owner })
        );
        localStorage.setItem("project_id", project.project.id);
        if (this.state.cheque.type == PAYMENT)
          window.location.pathname = `/summary-payment/${this.state.cheque.id}`;
        else if (this.state.cheque.type == RECEIVE)
          window.location.pathname = `/summary-receive/${this.state.cheque.id}`;
      }
    }

  }

  render() {
    const {
      isSeen,
      selected_sort,
      showModal,
      requestedFeedbackNotifyId,
      listData,
      showConfirm,
      project,
      accessDeniedModalShow
    } = this.state;
    const {
      loading,
      error,
      errorResponseNotification,
      loadingResponseNotification,
      feedbackData
    } = this.props;

    return (
      <Menu showMenu={this.props.show} close={() => this.props.handleShow(false)} isLarge={true} leftPosition={200}>
        {loadingResponseNotification[requestedFeedbackNotifyId] === false && feedbackData !== {} &&
        <FeedbackModal
          showModal={showModal}
          data={feedbackData}
          closeHandler={() => this.closeFeedbackModal()}
          sendScore={(id, score) => this.props.sendScore(id, score)}
        />
        }
        {accessDeniedModalShow && (
            <GuestsDeniedModal
                status={accessDeniedModalShow}
                handleShow={show =>
                    this.setState({
                      accessDeniedModalShow: show
                    })
                }
                projectId={project && project.project && project.project.id}
            />
        )}
        <Confirm
            show={showConfirm}
            content={{
              type: "info",
              icon: "icon mapsa-notification",
              message:`برای مشاهده‌ی جزئیات این چک لازم است ابتدا وارد پروژه‌ ${project.project && project.project.name} شوید.`,
              acceptButtonText: "ورود به پروژه",
              rejectButtonText: "بعدا"
            }}
            acceptHandler={() => {
              this.changeProject(project);
            }}
            loading={loading}
            rejectHandler={() => this.setState({ showConfirm: false })}
            close={() => this.setState({ showConfirm: false })}
        />
        <NotificationMenuContainer>
          <div className="header">
            <h1>اعلان‌ها</h1>
            <div className="sort-box">
              <SelectBox
                input={{
                  value: selected_sort,
                  onChange: value => this.handleChange(value)
                }}
                hasBorder={true}
                options={NOTIFICATION_SORT_TYPES}
                meta={{ error: undefined }}
                size="small"
              />
            </div>
          </div>
          {loading && BoxLoading()}
          {!loading && !error && (
            <NotificationListContainer>
              {listData.length > 0 &&
                listData.map((notify, key) => {
                  const notificationConfig = NOTIFICATION_WITH_ACTIONS_TYPES[notify.type];
                  return (
                    <Notify
                      key={key}
                      isSeen={
                        notify.read ||
                        (!errorResponseNotification[notify.id] &&
                          !loadingResponseNotification[notify.id] &&
                          isSeen[notify.id])
                      }
                      loading={loadingResponseNotification[notify.id]}
                      type={notify.type}
                      date={notify.created_date}
                      title={notify.title}
                      message={notify.message}
                      button1={{
                        text: notificationConfig.action2,
                        action: this.actionsHandler(
                          notificationConfig.action2,
                          notify.id,
                          notify.read,
                          notify.model_type,
                          notify.project,
                          notify.link
                        )
                      }}
                      button2={{
                        text: notificationConfig.action1,
                        action: this.actionsHandler(
                          notificationConfig.action1,
                          notify.id,
                          notify.read,
                          notify.model_type,
                          notify.project,
                          notify.link
                        )
                      }}
                    />
                  );
                })}
              {listData.length === 0 && (
                <EmptyState tabIcon={"icon mapsa-notification"}>
                  در واحد خبر رسانی، خبری برای خواندن وجود ندارد. بعدا به اینجا
                  سر بزنید.
                </EmptyState>
              )}
            </NotificationListContainer>
          )}
          {error && <div>emty state for error!</div> //Todo empty state for error
          }
        </NotificationMenuContainer>
      </Menu>
    );
  }
}

const mapStateToProps = store => {
  return {
    list: store.Notification.list,
    loading: store.Notification.loading,
    error: store.Notification.error,
    loadingResponseNotification: store.NotificationResponse.inProcess,
    errorResponseNotification: store.NotificationResponse.error,
    feedbackData: store.NotificationResponse.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getNotifications: sort => {
      dispatch(NotificationAction.getList(sort));
    },
    acceptInvitation: id => {
      dispatch(InvitationAction.accept(id));
    },
    rejectInvitation: id => {
      dispatch(InvitationAction.reject(id));
    },
    readNotification: id => {
      dispatch(NotificationAction.read(id));
    },
    getFeedback: id => {
      dispatch(FeedbackAction.getRequest(id));
    },
    readFeedbackNotification: id => {
      dispatch(FeedbackAction.readRequest(id));
    },
    sendScore: (id, score) => {
      dispatch(FeedbackAction.ScoreRequest(id, score));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Notifications));
